/**
 *
 * @param {String} label
 * @param {Number} num
 * Converts given label into plural if applicable
 */
const handlePlural = (label, num, doExcludeNumber = false) => {
	const n = typeof num === 'number' ? num : Number(num);
	const base = `${!doExcludeNumber ? n.toLocaleString() + ' ' : ''}${label}`;
	return n === 1 ? base : `${base}s`;
};

export default handlePlural;
